interface PinnedState {
  nodes: Record<string, string>
}

interface GraphRootState {
  graph?: {
    pinned?: PinnedState
  }
}

const defaultPinnedState: PinnedState = {
  nodes: {},
}


const selectPinned = (state: Record<string, unknown>): PinnedState => {
  const graph = (state as GraphRootState).graph
  return graph?.pinned ?? defaultPinnedState
}

export default selectPinned
